import getBackgroundImage from '@/lib/db/utils/getBackgroundImage'
import { getImageProps } from 'next/image'
import { SlotBox } from './CommonImageBG.styles'

function CommonImageBG({ children, width, height, sx, src, style, ...props }) {
  const {
    props: { srcSet },
  } = getImageProps({
    alt: 'Slot BG',
    width: 128,
    height: 128,
    src: src || '/imgs-slot-bg.png',
  })
  const backgroundImage = getBackgroundImage(srcSet)

  return (
    <SlotBox
      height={height ?? 'fit-content'}
      width={width ?? 'fit-content'}
      borderRadius={1}
      component={'span'}
      className='CommonImageBG'
      position={'relative'}
      style={{ '--slot-bg': backgroundImage, ...(style || {}) }}
      // Callers can still pass `sx`; it is only serialised for the ones that do.
      sx={sx}
      {...props}
    >
      {children}
    </SlotBox>
  )
}

export default CommonImageBG
